import { put, takeLatest, call } from 'redux-saga/effects';
import { GET_FOOD_LOG_RANGE } from './constants';
import { getFoodLogRangeSuccess, getFoodLogRangeError } from './actions';
import { fetchData } from '../api';

export function* getFoodLogRange({ from, to }) {
  try {
    const params = new URLSearchParams();
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    const url = `${process.env.REACT_APP_API_URL}/api/food-log${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    const config = {
      headers: {
        'x-auth-token': window.localStorage.token,
        'Content-Type': 'application/json',
      },
    };
    const logs = yield call(fetchData, url, config);
    yield put(getFoodLogRangeSuccess(logs));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response — fall through with the original.
    }
    yield put(getFoodLogRangeError(error));
  }
}

export default function* foodLogSaga() {
  yield takeLatest(GET_FOOD_LOG_RANGE, getFoodLogRange);
}
